<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_or32"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('speedWarning_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('speedWarning_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      :loading="loading"
      class="mytable-footer"
      height="80%"
      show-overflow
      :data="tableData"
      :sort-config="{ remote: true }"
      align="center"
      export-config
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人名称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentPhone"
          title="托运人电话"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentPhone"
            placeholder="请输入托运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人电话"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入实际承运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队名称"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamPhone"
          title="车队电话"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamPhone"
            placeholder="请输入车队电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="gmtCreated"
        title="发生时间"
        min-width="250"
        sortable
      />
      <vxe-table-column>
        <vxe-table-column
          field="happenPlace"
          title="发生位置"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.happenPlace"
            placeholder="请输入发生位置"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="latitudeLongitude"
          title="经纬度"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.latitudeLongitude"
            placeholder="请输入经纬度"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="speedCar"
          title="实时车速(km/h)"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.speedCarStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.speedCarEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { overspeedRange } from "@/api/orderform";

export default {
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-tms-api/overspeedRange/exportOverspeedWarnList", //导出接口
        name: "超速预警"
      },
      timer: "",
      orderCode: "",
      huoyuanDtile: "",
      partyType: this.$store.getters.party.partyType,
      loading: false,
      tableData: [],
      parentData: {},
      listQuery: {
        warnType: 0,
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      options: [
        {
          value: "0",
          label: "未接单"
        }
      ]
    };
  },
  created() {
    this.findList();
  },
  methods: {
    async findList() {
      this.loading = true;
      let response = await overspeedRange(this.listQuery);
      this.tableData = response.data.records;
      this.listQuery.total = response.data.total;
      this.sumObject = response.data.sumObject;
      this.loading = false;
    }
  }
};
</script>
<style>
.mytable-footer .vxe-body--row.row-green {
  background-color: #187;
  color: #2db7f5;
}
.mytable-footer .vxe-header--column.col-blue {
  background-color: #2db7f5;
  color: #fff;
}
.mytable-footer .vxe-body--column.col-red {
  color: #f00;
}
.mytable-footer .vxe-body--column.col-orange {
  color: #f60;
}
.mytable-footer .vxe-body--column.col-green {
  color: rgb(29, 47, 202);
}
</style>
